import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentSlideService } from '../../_services/current-slide.service';
import { SectionsService } from '../../_services/sections.service';
import { MatDialog } from '@angular/material';
import { StoryModalComponent } from '../../shared/story-modal/story-modal.component';
import { ArModalComponent } from '../../shared/ar-modal/ar-modal.component';


import { Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';


@Component({
	selector: 'sg-carousel',
	templateUrl: './carousel.component.html',
	styleUrls: ['./carousel.component.scss'],
	host: {'class': 'sg-carousel'}
})
export class CarouselComponent implements OnInit {

	private unsubscribe$ = new Subject<void>();

	public currentSlide = 0;
	public leaveSlide = 0;
	public enterSlide;
	public activeSectionPosition;
	public sections;
	public sectionsPosFirst;
	public sectionsPosLast;
	public transitionDurationSlide;
	public isSliding: boolean = false;

	public autoplay: boolean;
	timeoutAutoplay = null;

	public slides2;//same as slide but issue if keeping slides
	@Input() slides;

	

	constructor(
		private _router: Router,
		private _currentSlideService: CurrentSlideService,
		private _sectionsService: SectionsService,
		public dialog: MatDialog) {
	}

	ngOnInit() {
		var base = this;
		//this.autoplay = this._currentSlideService.getAutoplay();

		/*this._currentSlideService.autoplay
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(data => {
			this.autoplay = data;
		});*/

		this._currentSlideService.currentSlide
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(data => {
			this.currentSlide = data;
			
			this.getSlidesAnim();

			this.stopAutoplay();
			this.startAutoplay();
		});




		this.sections = this._sectionsService.getSections();
		this.sectionsPosFirst = this.sections[0].position;
		this.sectionsPosLast = this.sections[this.sections.length - 1].position;
		this._currentSlideService.setSlides(this.slides);
		this.slides2 = this._currentSlideService.getSlides();
		this.activeSectionPosition = this._sectionsService.getCurrentSectionPosition();
		this._sectionsService.changeSection
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(position => {
			this.activeSectionPosition = position;
		});


		setTimeout(()=>{
			this._currentSlideService.setAutoplay(true);
		}, 2000)

	}
	ngAfterViewInit(){
		var element = document.querySelector('.sg-carousel-item');
		this.transitionDurationSlide = parseFloat(getComputedStyle(element)['transitionDuration']) * 1000;

		//start autoplay
		this._currentSlideService.autoplay
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(data => {
			this.autoplay = data;
			if(!this.autoplay){
				//stop autoplay
				this.stopAutoplay();
			}
			else{
				//start autoplay
				this.startAutoplay();
			}
		});
		if(this.autoplay){
			this.startAutoplay();
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		this._currentSlideService.setSlides(this.slides);
		this.slides2 = this._currentSlideService.getSlides();
	}

	carouselNext(){
		//clearInterval(this.timeoutAutoplay);
		clearTimeout(this.timeoutAutoplay);
		if(this.currentSlide < this.slides2.length - 1){
			if(!this.isSliding){
				this.isSliding = true;
				this.currentSlide++;
				this._currentSlideService.setCurrenSlide(this.currentSlide);
				setTimeout(() => {
					this.isSliding = false;
				}, this.transitionDurationSlide)
			}
		}
		else{
			this._currentSlideService.setAutoplay(false);
			let section = this.sections.find(data => data.position === this._sectionsService.getCurrentSectionPosition());
			let sectionPosition = section.position + 1;
			if(sectionPosition <= this.sectionsPosLast){
				this._sectionsService.setCurrentPosition(sectionPosition)
			}
			else{
				this._sectionsService.setCurrentPosition(0)	
			}
			
			this._router.navigate(['']);
		}
	}
	carouselPrev(){
		this.stopAutoplay();
		if(this.currentSlide > 0 && !this.isSliding){
			if(!this.isSliding){
				this.isSliding = true;
				this.currentSlide--;
				//this.getSlidesAnim();
				this._currentSlideService.setCurrenSlide(this.currentSlide);
				setTimeout(() => {
					this.isSliding = false;
				}, this.transitionDurationSlide)
			}
		}
		/*else{
			let goSection = this.activeSectionPosition - 1;
			if(goSection >= this.sectionsPosFirst){
				let section = this.sections.find(data => data.position === goSection);
				this._router.navigate([section.routeName]);
				this._currentSlideService.setCurrenSlide(0);
			}
		}*/
	}

	startAutoplay(){
		let autoplaySpeed = 10000;
		if(this.autoplay){
			this.slides2 = this._currentSlideService.getSlides();
			this.timeoutAutoplay = setTimeout(() => {
				this.carouselNext();
			}, autoplaySpeed);
		}
	}
	stopAutoplay(){
		clearTimeout(this.timeoutAutoplay);
	}
	

	getSlidesAnim(){
		this.enterSlide = this.currentSlide;
		//the setTimeout allows to have a sweet animation when sliding to a different slide (more than the next / prev)
		setTimeout(() => {
			this.enterSlide = undefined;
			this.leaveSlide = this.currentSlide;
		}, this.transitionDurationSlide)
	}


	swipeLeft(){
		this.carouselNext();
	}
	swipeRight(){
		this.carouselPrev();
	}


	launchModalVideo(video){
		let currentAutoplay = this.autoplay;
		if(currentAutoplay === true){
			this._currentSlideService.setAutoplay(false);
		}
		let videoModal = this.dialog.open(StoryModalComponent, {
			data: { 
				type: 'video',
				contentUrl: video
				
			}
		});
		videoModal.afterClosed()
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(result => {
			if(currentAutoplay === true){
				this._currentSlideService.setAutoplay(true);
			}
		});
	}

	launchModalAR(text, id){
		let currentAutoplay = this.autoplay;
		if(currentAutoplay === true){
			this._currentSlideService.setAutoplay(false);
		}
		let arModal = this.dialog.open(ArModalComponent, {
			data: { 
				text: text,
				id: id
			}
		});
		arModal.afterClosed()
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(result => {
			if(currentAutoplay === true){
				this._currentSlideService.setAutoplay(true);
			}
		});
	}


	goScrollSection(i){
		let section = i;
		let curSlide = this.currentSlide;
		let $scrollSection = $('.sg-carousel-item.item-'+curSlide+' .sg-carousel-item__content-wrap.scroll');
		let carouselH = $('.sg-carousel').height();

		$scrollSection.stop().animate({
			scrollTop: carouselH * section
		}, 1000);
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

}
